// extracted by mini-css-extract-plugin
export default {"CommonEventQuests":"CommonEventQuests-module-b3e29725892a4e7c8324"};